<template>
  <div
    class="calandr_main calandr_main_glob no_mobile calendar_desktop relative"
  >
    <div class="desk-flex mb--22">
      <div class="relative">
        <div
          @click="isDatePicker = !isDatePicker"
          v-click-outside="hide"
          class="glob-date-click tx--blue2 cursor-p flex"
        >
          {{ getSelectedDate }}
          <img src="/assets/img/svg/ic-date.svg" />
        </div>
        <div class="glob-date-open bg--white" v-show="isDatePicker">
          <vue-cal
            ref="vuecal"
            xsmall
            locale="he"
            :time="false"
            :startWeekOnSunday="true"
            :selected-date="selectedDate"
            hide-view-selector
            active-view="month"
            :disable-views="['years', 'year', 'week', 'day']"
            @cell-focus="onDatePicker"
            class="vuecal--green-theme vuecal--rounded-theme mini-month"
            :events="smallCalEvents"
            events-count-on-year-view
            @view-change="changeSmallCalendar"
          >
            <template v-slot:weekday-heading="{ heading }">
              <span v-if="heading.label == 'ראשון'">א׳</span>
              <span v-if="heading.label == 'שני'">ב׳</span>
              <span v-if="heading.label == 'שלישי'">ג׳</span>
              <span v-if="heading.label == 'רביעי'">ד׳</span>
              <span v-if="heading.label == 'חמישי'">ה׳</span>
              <span v-if="heading.label == 'שישי'">ו׳</span>
              <span v-if="heading.label == 'שבת'">ש׳</span>
            </template>
            <template v-slot:events-count="{ events }">
              <span>
                {{ countDot(events) }}
              </span>
            </template>
          </vue-cal>
        </div>
      </div>
      <div class="sel-white select-month-wrap" v-if="options && options.length">
        <select2 v-model="selected">
          <option :value="option.id" v-for="option in options" :key="option.id">
            <template v-if="option.label">
              {{ option.label }}
            </template>
          </option>
        </select2>
      </div>
    </div>
    <div
      id="app"
      v-if="
        splitDays && splitDays.length && fullSplitDays && fullSplitDays.length
      "
    >
      <vue-cal
        class="vuecal--green-theme scroll has--scroll-x"
        locale="he"
        :startWeekOnSunday="true"
        active-view="day"
        :disable-views="['years', 'year', 'month', 'week']"
        hide-view-selector
        :time-from="timeFrom"
        :time-to="timeTo"
        :timeStep="15"
        :timeCellHeight="50"
        :events="eventsToEdit"
        hide-title-bar
        :sticky-split-labels="true"
        :split-days="splitDays"
        @event-mouse-enter="enterHoverEvent"
        @event-mouse-leave="leaveHoverEvent"
        :selected-date="selectedDate"
        @view-change="initCalendarDesktop"
        :min-cell-width="200"
        :min-split-width="200"
      >
        <template v-slot:event="{ event }">
          <div v-if="event.type === 'block'"></div>
          <div v-if="event.type === 'appointment'">
            <div
              class="cal-week-inline"
              @click="$router.push('/app-info/' + event.id)"
            >
              <div
                class="vuecal__event-content line-clamp"
                v-html="event.content"
              ></div>
            </div>
            <div
              v-show="
                selectedEventHover && selectedEventHover._eid === event._eid
              "
              class="cal-hover-info tx--black"
            >
              <div class="cal-hover-info-in">
                <h2 class="title--32">
                  {{ getDate(event.start) }} {{ getTime(event.start) }}
                  <div>{{ event.patientName }}</div>
                </h2>
                <div class="cal-hover-info-list">
                  <div class="flex">
                    <div>סוג התור</div>
                    <div>{{ event.appointmentName }}</div>
                  </div>
                  <div class="flex">
                    <div>ת.ז.</div>
                    <div>{{ event.patientPassport }}</div>
                  </div>
                  <div class="flex">
                    <div>תאריך לידה</div>
                    <div>{{ getDate(event.patientBirthDate) }}</div>
                  </div>
                  <div class="flex">
                    <div>טלפון נייד</div>
                    <div>{{ event.patientPhone }}</div>
                  </div>
                  <div
                    v-if="
                      event.scheduled_by && getScheduledBy(event.scheduled_by)
                    "
                    class="flex"
                  >
                    <div>מקור שיבוץ</div>
                    <div class="flex flex--start">
                      <img
                        :src="getScheduledBy(event.scheduled_by).image"
                        :alt="getScheduledBy(event.scheduled_by).text"
                      />
                      {{ getScheduledBy(event.scheduled_by).text }}
                    </div>
                  </div>
                </div>
                <!-- END cal-hover-info-list -->
                <div class="cal-hover-info-note">
                  <div class="text text--20">
                    {{ event.notes }}
                  </div>
                  <img
                    v-if="
                      event.arrival_approval &&
                        event.arrival_approval.includes('approved')
                    "
                    src="/assets/img/svg/ok-green.svg"
                  />
                </div>
              </div>
            </div>
            <!-- END cal-hover-info -->
          </div>

          <!-- <div v-if="event.type === 'surgery'">
            <div class="vuecal__event-title">ניתוח</div>
          </div> -->
        </template>
      </vue-cal>
    </div>
  </div>
</template>

<script>
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/he.js";
import "vue-cal/dist/vuecal.css";
import { mapGetters, mapMutations } from "vuex";
import ClickOutside from "vue-click-outside";
import { getHash } from "../../utilities/hash.js";

export default {
  name: "CalendarDesktop",
  components: {
    VueCal
  },
  props: {
    events: {
      type: Array,
      require: true
    },
    smallCalEvents: {
      type: Array,
      require: true
    }
  },
  directives: {
    ClickOutside
  },
  data() {
    return {
      selectedEventHover: null,
      selectedDate: new Date(),
      isDatePicker: false,
      selected: 0,
      options: [],
      fullSplitDays: []
    };
  },
  computed: {
    ...mapGetters(["allRooms", "doctorRooms", "activeDoctor"]),
    eventsToEdit() {
      if (!this.splitDays || !this.splitDays.length) return this.events;
      return this.events.map(ev => {
        if (ev.room) {
          let index = this.fullSplitDays.findIndex(
            split => split.roomKey === ev.room.key
          );
          if (index !== -1) return { ...ev, split: index };
        }
        return { ...ev };
      });
    },
    getSelectedDate() {
      return this.$moment(this.selectedDate).format("L");
    },
    splitDays() {
      if (!this.options || !this.options.length) return [];
      if (this.selected == 0) return this.options.slice(1);
      return this.options.filter(option => option.id == this.selected);
    },
    timeFrom() {
      const today = this.getDate(this.selectedDate);
      const evDates = this.events.filter(
        ev => this.getDate(ev.start) === today
      );
      let hoursStart = evDates.map(d => {
        return parseInt(this.getTime(d.start).slice(0, -3));
      });
      let min = Math.min(...hoursStart);
      if (!min || !hoursStart || !hoursStart.length) return 0 * 60;
      else return (min - 1) * 60;
    },
    timeTo() {
      const today = this.getDate(this.selectedDate);
      const evDates = this.events.filter(
        ev => this.getDate(ev.start) === today
      );
      let hoursEnd = evDates.map(d => {
        return parseInt(this.getTime(d.end).slice(0, -3));
      });
      let max = Math.max(...hoursEnd);
      if (max === 24 || !hoursEnd || !hoursEnd.length) return 24 * 60;
      else return (max + 1) * 60;
    }
  },
  methods: {
    ...mapMutations(["SET_DOCTOR_ROOMS"]),
    getTime(date) {
      return this.$moment(date).format("LT");
    },
    getDate(date) {
      return this.$moment(date).format("L");
    },
    enterHoverEvent(ev) {
      if (ev.type !== "appointment") return;
      this.selectedEventHover = ev;
    },
    leaveHoverEvent(ev) {
      this.selectedEventHover = null;
    },
    countDot(events) {
      return events
        ? events.filter(e => e.type === "appointment" || e.type === "surgery")
            .length
        : 0;
    },
    hide(ev) {
      if (
        !this.isDatePicker ||
        ev.target.ariaLabel === "Next month" ||
        ev.target.ariaLabel === "Previous month"
      )
        return;
      this.isDatePicker = false;
    },
    initCalendarDesktop(ev) {
      this.selectedDate = ev.startDate;
      window.location.hash = getHash({
        date: ev.startDate.format("YYYY-MM-DD"),
        view: "day"
      });
      this.$emit("initCalendarDesktop", {
        currentDate: new Date(ev.startDate)
      });
    },
    changeSmallCalendar(ev) {
      this.$emit("initCalendarDesktop", {
        currentDate: new Date(ev.startDate),
        type: "small"
      });
    },
    onDatePicker(ev) {
      this.selectedDate = ev;
      window.location.hash = getHash({
        date: ev.format("YYYY-MM-DD"),
        view: "day"
      });
      this.$emit("initCalendarDesktop", {
        currentDate: new Date(ev)
      });
      this.isDatePicker = false;
    },
    onNext() {
      this.$refs.vuecal.next();
    },
    getScheduledBy(type) {
      return this.$store.getters["getAppScheduledBy"](type, false);
    }
  },
  watch: {
    doctorRooms(val) {
      if (!val && !val.length) return;
      this.options = [];
      let id = 1;
      this.options.push({ id: 0, label: "הכל" });
      for (const key in this.allRooms) {
        if (val.includes(this.allRooms[key].value)) {
          this.options.push({
            id: id++,
            label: this.allRooms[key].name,
            roomKey: this.allRooms[key].value
          });
        }
      }
      this.fullSplitDays = [...this.options];
    },
    hashData(val) {
      const hasDate = val ? val.date : false;
      if (hasDate) {
        if (this.selectedDate !== new Date(hasDate)) {
          this.selectedDate = new Date(hasDate);
        }
      } else {
        this.selectedDate = new Date();
      }
    }
  },
  async created() {
    const hasDate = this.hashData ? this.hashData.date : false;
    if (hasDate) {
      this.selectedDate = new Date(hasDate);
      this.$emit("initCalendarDesktop", {
        currentDate: new Date(hasDate),
        type: "small"
      });
    } else {
      this.$emit("initCalendarDesktop", {
        currentDate: new Date(),
        type: "small"
      });
    }
    if (!this.allRooms || !this.doctorRooms) return;
    let id = 1;
    this.options.push({ id: 0, label: "הכל" });
    for (const key in this.allRooms) {
      if (this.doctorRooms.includes(key)) {
        this.options.push({
          id: id++,
          label: this.allRooms[key].name,
          roomKey: this.allRooms[key].value
        });
      }
    }
    this.fullSplitDays = [...this.options];
  }
};
</script>

<style>
.scroll {
  overflow: scroll;
}
</style>
